// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_BlpW9","wrapper":"wrapper_rt33h"};